import {Component, Injector, Input, OnInit, ViewChild} from '@angular/core';
import {BaseResultListComponent} from '@twpub/shared/components/base';
import {FieldProps, ResultList, TermSearchResult} from '@twpub/core/models';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {
  ClientConfigurationScheme,
  ComponentConfiguration,
  ComponentInit,
  fromPageEvent,
  InitialConfig
} from '@twpub/core/utils';
import {ResultListProp} from '@twpub/core/constants';
import {ComponentCategory, ControlType} from '@twpub/core/enums';
import {Router} from '@angular/router';
import {FieldService} from '@twpub/core/services';
import {NgClass} from '@angular/common';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {CardContentComponent} from '../card-content/card-content.component';

@Component({
  selector: 'pub-card-result-list',
  templateUrl: './card-result-list.component.html',
  styleUrls: ['./card-result-list.component.scss'],
  standalone: true,
  imports: [NgClass, MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatProgressSpinner, CardContentComponent, MatPaginator]
})
export class CardResultListComponent extends BaseResultListComponent implements ResultList, OnInit {
  @Input() selectedLang?: string;
  imageFields: string[] = [];
  loadingResultsLabel = $localize`:@@cardResultList.loadingResults:Loading results...`;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  static readonly compName = 'CardResultListComponent';

  static Init = class extends ComponentInit {
    readonly scheme = ClientConfigurationScheme.DEFAULT;
    override props: FieldProps[] = [
      {
        key: ResultListProp.InitialSearch,
        label: 'Results visible on page load',
        controlType: ControlType.Boolean,
        description: 'Automatically list all terms when page is opened, before any search'
      }
      /*
            {
              key: ResultListProp.Fields,
              label: 'Field names',
              controlType: ControlType.Textbox,
              description: 'Enter names of entry fields (concept and term level) to be included in the result list. Separate names by semi-colon (;)'
            }
      */
    ];

    initialConfig = new Map([[ResultListProp.HasResultPage, true]]);

    constructor() {
      super(CardResultListComponent, CardResultListComponent.compName, 'Card Result List', [ComponentCategory.ResultList]);
    }

    createConfig(initialConfig: InitialConfig = this.initialConfig) {
      return new ComponentConfiguration<ResultList>(CardResultListComponent, this.name, initialConfig);
    }
  }

  constructor(injector: Injector, router: Router, private fieldService: FieldService) {
    super(injector);
  }

  ngOnInit(): void {
    const pData = this.sharedStateService.getPaginationData();
    pData.pageSize = 15;
    this.sharedStateService.setPaginationData(pData);
    this.onInit();
    this.fetchLangNames();
    this.performSearch(pData, true);
    this.imageFields = this.fieldService.getImageFields();
  }

  pageChange(event: PageEvent) {
    this.performSearch(fromPageEvent(event), true);
  }

  override resultClick(res: TermSearchResult, index?: number): void {
    const conceptId = res.term.conceptId;
    const termId = res.term.id;
    this.sharedStateService.setResultPage(true);
    this.sharedStateService.selectConcept({conceptId, termId, index});
  }
}
